import { FontWeights } from '@uifabric/styling';
export var LabelStyles = function LabelStyles(props) {
  var theme = props.theme,
      disabled = props.disabled;
  var palette = theme.palette;
  return {
    root: [{
      fontWeight: FontWeights.semibold
    }, disabled && {
      color: palette.neutralTertiary
    }]
  };
};